export class RulebookColumnModel {
  regulator: boolean;
  effectiveDate: boolean;
  version: boolean;
  isApplicable: boolean;
  isRead: boolean;
  isOperative: boolean;
  title: boolean;
  part: boolean;
  title1: boolean;
  title2: boolean;
  title3: boolean;
  title4: boolean;
  title5: boolean;
  ruleId: boolean;
  owner: boolean;

  constructor() {
    this.regulator = true;
    this.effectiveDate = true;
    this.version = true;
    this.isApplicable = true;
    this.isRead = true;
    this.isOperative = true;
    this.title = true;
    this.title1 = true;
    this.title2 = true;
    this.title3 = true;
    this.title4 = true;
    this.title5 = true;
    this.ruleId = true;
    this.part = true;
    this.owner = true;
  }
}
